import zhCNMenu from '../zh-CN/menu';

export default {
  ...zhCNMenu,
  'menu.attraction.setting': '招商設定',
  'menu.attraction.claimConversion': '領取與轉化規則',
  'menu.navigation.contractSettings': '合同設定',
  'menu.contractTypes': '合同類型',
  'menu.navigation.contractHandling': '合同辦理',
  'menu.navigation.contractAll': '全部合同',
  'menu.navigation.contractMine': '我的合同',
  'menu.navigation.contractTodo': '待辦合同',
  'menu.contractTemplates': '合同範本庫',
  'menu.contractBillingRules': '計費規則',
  'menu.navigation.module.home': '首頁',
  'menu.navigation.module.assets': '房源',
  'menu.navigation.module.attraction': '招商',
  'menu.navigation.module.enterprises': '企業',
  'menu.navigation.module.reports': '報表',
  'menu.navigation.module.contracts': '合同',
  'menu.navigation.module.property': '物業',
  'menu.navigation.module.innovation': '企服',
  'menu.navigation.module.operations': '運營',
  'menu.navigation.module.hr': '人事',
  'menu.navigation.module.finance': '財務',
  'menu.navigation.module.evaluation': '評價',
  'menu.navigation.module.settings': '設置',
  'menu.attraction.leads': '線索',
  'menu.attraction.customers': '客戶',
  'menu.leadAll': '全部',
  'menu.leadMine': '我的线索',
  'menu.leadPool': '待领线索',
  'menu.customerAll': '全部',
  'menu.customerMine': '我的客户',
  'menu.customerPool': '待领客户',
  'menu.attraction.leadAll': '全部',
  'menu.attraction.leadMine': '我的线索',
  'menu.attraction.leadPool': '待领线索',
  'menu.attraction.customerAll': '全部',
  'menu.attraction.customerMine': '我的客户',
  'menu.attraction.customerPool': '待领客户',
  'menu.attraction.contacts': '聯絡人',
  'menu.attraction.opportunities': '商機',
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.assets': '資產房源',
  'menu.business': '業務管理',
  'menu.contracts': '合同台賬',
  'menu.innovation': '科創服務',
  'menu.hr': '人事管理',
  'menu.finance': '財務管理',
  'menu.finance.overview': '財務總覽',
  'menu.finance.receivables': '應收管理',
  'menu.finance.receipts': '收款管理',
  'menu.finance.collectionLedger': '催繳台賬',
  'menu.finance.expenses': '費用申請',
  'menu.finance.invoices': '發票管理',
  'menu.reports': '數據報表',
  'menu.reports.overview': '報表總覽',
  'menu.reports.investment': '招商報表',
  'menu.reports.finance': '財務收費報表',
  'menu.reports.property': '物業運維報表',
  'menu.reports.settings': '報表設置',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.settings': '系統設置',
  'menu.settings.permissions': '權限管理',
  'menu.settings.spaceConfig': '房源配置',
  'menu.settings.approvalConfig': '審批配置',
  'menu.login': '登錄',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.park.spaceManagement': '房源管理',
  'menu.park.spaceManagement.spacesOverview': '房源總覽',
  'menu.park.spaceManagement.spaces': '房源檔案',
  'menu.park.spaceManagement.otherAssets': '其他資產',
  'menu.park.spaceManagement.spaceIncubation': '孵化檔案',
  'menu.park.spaceManagement.spaceDetail': '房源詳情',
  'menu.park.spaceManagement.spaceUsage': '房源使用',
  'menu.park.property': '物業管理',
  'menu.property': '物業',
  'menu.property.propertyDashboard': '物業看板',
  'menu.property.workOrders': '物業工單',
  'menu.property.propertySlaRules': '工單時效規則',
  'menu.property.accessControl': '門禁管理',
  'menu.property.parking': '停車管理',
  'menu.property.meetingRoom': '會議室管理',
  'menu.property.energy': '能耗管理',
  'menu.property.energySpaces': '房源台賬',
  'menu.property.energyLedger': '抄表台賬',
  'menu.property.energyAccounts': '企業賬戶',
  'menu.property.energyRates': '計費規則',
  'menu.property.iotDevices': '物聯設備',
  'menu.enterprises.attraction': '招商入駐',
  'menu.attraction': '招商管理',
  'menu.attraction.investmentProjects': '招商項目',
  'menu.attraction.admissionApplications': '入駐申請',
  'menu.attraction.list': '企業庫',
  'menu.enterprises.incubation': '孵化輔導',
  'menu.enterprises.archives': '企業檔案',
  'menu.todos': '待辦中心',
  'menu.services.handling': '事項辦理',
  'menu.services.marketplace': '服務市場',
  'menu.resources.technology': '科技資源',
  'menu.portal.site': '門戶內容',
  'menu.portal.publish': '發布設置',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
  'menu.park': '園區',
  'menu.enterprises': '企業',
  'menu.services': '服務',
  'menu.operations.partyBuilding': '黨建',
  'menu.operations': '運營管理',
  'menu.evaluation': '評價',
  'menu.overview': '概覽',
  'menu.evaluation.overview': '概覽',
  'menu.growth.archives': '成長檔案',
  'menu.portal.site.banners': '橫幅管理',
  'menu.navigation.admission': '入駐與遷出',
  'menu.navigation.incubationGrowth': '孵化成長',
  'menu.navigation.resourceMatching': '資源對接',
  'menu.navigation.detail': '詳情',
  'menu.navigation.create': '新增',
  'menu.navigation.edit': '編輯',
  'menu.navigation.claimReview': '認領審核',
  'menu.navigation.reads': '閱讀記錄',
  'menu.portal': '門戶管理',
  'menu.park.leases': '租賃管理',
};
